"use strict";
var _UserAddress_model;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const structured_clone_1 = tslib_1.__importDefault(require("@ungap/structured-clone"));
const updateModel = {
    data: {
        type: 'user_address',
        attributes: {},
    },
};
class UserAddress {
    constructor(data) {
        _UserAddress_model.set(this, {});
        const payload = (0, structured_clone_1.default)(updateModel);
        payload.data.attributes = data;
        if (!payload.data.attributes.main) {
            payload.data.attributes.main = false;
        }
        tslib_1.__classPrivateFieldSet(this, _UserAddress_model, payload, "f");
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _UserAddress_model, "f");
    }
}
exports.default = UserAddress;
_UserAddress_model = new WeakMap();
//# sourceMappingURL=index.js.map